'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _es6Promise = _interopRequireDefault(require("es6-promise"));

var _messageList = _interopRequireDefault(require("../message-list"));

var _dashboardUncheckedFarmList = _interopRequireDefault(require("../dashboard-unchecked-farm-list"));

var _dashboardOpenMembershipFeeList = _interopRequireDefault(require("../dashboard-open-membership-fee-list"));

var _dashboardProjectList = _interopRequireDefault(require("../dashboard-project-list"));

var _dashboardUserList = _interopRequireDefault(require("../dashboard-user-list"));

var _formInputs = require("../form-inputs");

var _fetchUtils = _interopRequireDefault(require("../../fetchUtils"));

var _conf = require("./../../conf");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

_es6Promise.default.polyfill();

var AdminDashboard = /*#__PURE__*/function (_React$Component) {
  _inherits(AdminDashboard, _React$Component);

  function AdminDashboard(props) {
    var _this;

    _classCallCheck(this, AdminDashboard);

    _this = _possibleConstructorReturn(this, (AdminDashboard.__proto__ || Object.getPrototypeOf(AdminDashboard)).call(this, props));
    _this.state = {
      listsConfig: {
        user: {
          label: props.t('user list'),
          anchor: 'user-list',
          visible: false
        },
        message: {
          label: props.t('message list'),
          anchor: 'message-list',
          visible: false
        },
        vomhof: {
          label: props.t('open list vomhof'),
          anchor: 'vomhof-list',
          visible: false
        },
        brunch: {
          label: props.t('open list brunch'),
          anchor: 'brunch-list',
          visible: false
        },
        schub: {
          label: props.t('open list schub'),
          anchor: 'schub-list',
          visible: false
        },
        stallvisite: {
          label: props.t('open list stallvisite'),
          anchor: 'stallvisite-list',
          visible: false
        },
        lockpfosten: {
          label: props.t('open list lockpfosten'),
          anchor: 'lockpfosten-list',
          visible: false
        },
        toh: {
          label: props.t('open list toh'),
          anchor: 'toh-list',
          visible: false
        },
        lgw: {
          label: props.t('open list lgw'),
          anchor: 'lgw-list',
          visible: false
        },
        openMembershipFee: {
          label: props.t('Offene Mitgliederbeiträge'),
          anchor: 'open-membership-fee-list',
          visible: false
        },
        uncheckedFarm: {
          label: props.t('Nicht geprüfte Hofdaten'),
          anchor: 'unchecked-farm-list',
          visible: false
        }
      }
    };
    _this.initSubMenu = _this.initSubMenu.bind(_assertThisInitialized(_this));
    _this.changeValueCheckbox = _this.changeValueCheckbox.bind(_assertThisInitialized(_this));
    _this.loadSettings = _this.loadSettings.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(AdminDashboard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
      this.initSubMenu();
      this.loadSettings();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          t = _this$props.t,
          i18n = _this$props.i18n,
          history = _this$props.history;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: 'comp-admin-dashboard'
      }, this.getSettingsToolbar(), this.state.listsConfig.user.visible && /*#__PURE__*/_react.default.createElement("div", {
        className: 'user-list'
      }, /*#__PURE__*/_react.default.createElement("h2", {
        id: this.state.listsConfig.user.anchor
      }, this.state.listsConfig.user.label), /*#__PURE__*/_react.default.createElement(_dashboardUserList.default, {
        t: t,
        history: history,
        loadUserUrl: "/api/".concat(i18n.language, "/administration/user"),
        i18n: i18n,
        backendUserGroupId: this.props.roleId
      })), this.state.listsConfig.message.visible && /*#__PURE__*/_react.default.createElement("div", {
        className: 'message-list'
      }, /*#__PURE__*/_react.default.createElement("h2", {
        id: this.state.listsConfig.message.anchor
      }, this.state.listsConfig.message.label), /*#__PURE__*/_react.default.createElement(_messageList.default, {
        history: history
      })), this.state.listsConfig.vomhof.visible && /*#__PURE__*/_react.default.createElement("div", {
        className: 'project-vomhof'
      }, /*#__PURE__*/_react.default.createElement(_dashboardProjectList.default, {
        t: t,
        projectKey: 'vomhof',
        i18n: this.props.i18n,
        history: this.props.history,
        enableAssignToUser: true,
        loadProjectUrl: "/api/".concat(this.props.i18n.language, "/") + 'administration/project/open-publish-requests?projects=vomhof',
        label: this.state.listsConfig.vomhof.label,
        anchor: this.state.listsConfig.vomhof.anchor
      })), this.state.listsConfig.brunch.visible && /*#__PURE__*/_react.default.createElement("div", {
        className: 'project-brunch'
      }, /*#__PURE__*/_react.default.createElement(_dashboardProjectList.default, {
        t: t,
        projectKey: 'brunch',
        i18n: this.props.i18n,
        history: this.props.history,
        enableAssignToUser: true,
        loadProjectUrl: "/api/".concat(this.props.i18n.language, "/") + 'administration/project/open-publish-requests?projects=brunch',
        label: this.state.listsConfig.brunch.label,
        anchor: this.state.listsConfig.brunch.anchor
      })), this.state.listsConfig.schub.visible && /*#__PURE__*/_react.default.createElement("div", {
        className: 'project-schub'
      }, /*#__PURE__*/_react.default.createElement(_dashboardProjectList.default, {
        t: t,
        projectKey: 'schub',
        i18n: this.props.i18n,
        history: this.props.history,
        enableAssignToUser: true,
        loadProjectUrl: "/api/".concat(this.props.i18n.language, "/") + 'administration/project/open-publish-requests?projects=schub',
        label: this.state.listsConfig.schub.label,
        anchor: this.state.listsConfig.schub.anchor
      })), this.state.listsConfig.stallvisite.visible && /*#__PURE__*/_react.default.createElement("div", {
        className: 'project-stallvisite'
      }, /*#__PURE__*/_react.default.createElement(_dashboardProjectList.default, {
        t: t,
        projectKey: 'stallvisite',
        i18n: this.props.i18n,
        history: this.props.history,
        enableAssignToUser: true,
        loadProjectUrl: "/api/".concat(this.props.i18n.language, "/") + 'administration/project/open-publish-requests?projects=stallvisite',
        label: this.state.listsConfig.stallvisite.label,
        anchor: this.state.listsConfig.stallvisite.anchor
      })), this.state.listsConfig.lockpfosten.visible && /*#__PURE__*/_react.default.createElement("div", {
        className: 'project-lockpfosten'
      }, /*#__PURE__*/_react.default.createElement(_dashboardProjectList.default, {
        t: t,
        projectKey: 'lockpfosten',
        i18n: this.props.i18n,
        history: this.props.history,
        enableAssignToUser: true,
        loadProjectUrl: "/api/".concat(this.props.i18n.language, "/") + 'administration/project/open-publish-requests?projects=lockpfosten',
        label: this.state.listsConfig.lockpfosten.label,
        anchor: this.state.listsConfig.lockpfosten.anchor
      })), this.state.listsConfig.toh.visible && /*#__PURE__*/_react.default.createElement("div", {
        className: 'project-toh'
      }, /*#__PURE__*/_react.default.createElement(_dashboardProjectList.default, {
        t: t,
        projectKey: 'toh',
        i18n: this.props.i18n,
        history: this.props.history,
        enableAssignToUser: true,
        loadProjectUrl: "/api/".concat(this.props.i18n.language, "/") + 'administration/project/open-publish-requests?projects=toh',
        label: this.state.listsConfig.toh.label,
        anchor: this.state.listsConfig.toh.anchor
      })), this.state.listsConfig.lgw.visible && /*#__PURE__*/_react.default.createElement("div", {
        className: 'project-lgw'
      }, /*#__PURE__*/_react.default.createElement(_dashboardProjectList.default, {
        t: t,
        projectKey: 'lgw',
        i18n: this.props.i18n,
        history: this.props.history,
        enableAssignToUser: true,
        loadProjectUrl: "/api/".concat(this.props.i18n.language, "/") + 'administration/project/open-publish-requests?projects=lgw',
        label: this.state.listsConfig.lgw.label,
        anchor: this.state.listsConfig.lgw.anchor
      })), this.state.listsConfig.openMembershipFee.visible && /*#__PURE__*/_react.default.createElement("div", {
        className: 'open-membership-fee-list'
      }, /*#__PURE__*/_react.default.createElement("h2", {
        id: this.state.listsConfig.openMembershipFee.anchor
      }, this.state.listsConfig.openMembershipFee.label), /*#__PURE__*/_react.default.createElement(_dashboardOpenMembershipFeeList.default, {
        t: t,
        history: history,
        i18n: i18n
      })), this.state.listsConfig.uncheckedFarm.visible && /*#__PURE__*/_react.default.createElement("div", {
        className: 'unchecked-farm-list'
      }, /*#__PURE__*/_react.default.createElement("h2", {
        id: this.state.listsConfig.uncheckedFarm.anchor
      }, this.state.listsConfig.uncheckedFarm.label), /*#__PURE__*/_react.default.createElement(_dashboardUncheckedFarmList.default, {
        t: t,
        history: history,
        i18n: i18n
      })));
    }
  }, {
    key: "getSettingsToolbar",
    value: function getSettingsToolbar() {
      var _this2 = this;

      return /*#__PURE__*/_react.default.createElement("div", {
        id: 'settings',
        className: 'settings-toolbar grid-x grid-padding-x medium-up-2 large-up-3'
      }, Object.keys(this.state.listsConfig).map(function (key) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: 'cell',
          key: "".concat(_this2.state.listsConfig[key].anchor, "-setting")
        }, /*#__PURE__*/_react.default.createElement(_formInputs.CheckboxInput, {
          name: key,
          label: _this2.state.listsConfig[key].label,
          value: _this2.state.listsConfig[key].visible,
          id: "".concat(_this2.state.listsConfig[key].anchor, "-setting"),
          onChange: function onChange(e) {
            return _this2.changeValueCheckbox(e);
          }
        }));
      }));
    }
  }, {
    key: "initSubMenu",
    value: function initSubMenu() {
      var _this3 = this;

      if (this.props.getSubMenuConfig) {
        var config = Object.keys(this.state.listsConfig).filter(function (key) {
          return _this3.state.listsConfig[key].visible;
        }).map(function (key) {
          return _this3.state.listsConfig[key];
        });
        config.unshift({
          label: this.props.t('Settings'),
          anchor: 'settings',
          visible: true
        });
        this.props.getSubMenuConfig(config);
      }
    }
    /**
     *
     * @param e
     */

  }, {
    key: "changeValueCheckbox",
    value: function changeValueCheckbox(e) {
      var _this4 = this;

      var name = e.target.name,
          value = e.target.checked;
      this.setState(function (prev) {
        prev.listsConfig[name].visible = value;
        return prev;
      }, function () {
        _this4.updateSettings(name, value);

        _this4.initSubMenu();
      });
    }
  }, {
    key: "loadSettings",
    value: function loadSettings() {
      var _this5 = this;

      fetch(_conf.api.dashboardSettingsApiUrlTemplate('de'), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (result) {
        if (_this5._isMounted) {
          _this5.setState(function (prev) {
            Object.keys(prev.listsConfig).map(function (key) {
              prev.listsConfig[key].visible = result[key] && result[key] === 'true';
            });
            return prev;
          }, _this5.initSubMenu);
        }
      }).catch(function (err) {
        void 0;
      });
    }
  }, {
    key: "updateSettings",
    value: function updateSettings(key, value) {
      fetch(_conf.api.dashboardSettingsUpdateApiUrlTemplate('de', key, value), {
        credentials: 'include',
        method: 'POST'
      }).catch(function (err) {
        void 0;
      });
    }
  }]);

  return AdminDashboard;
}(_react.default.Component);

AdminDashboard.propTypes = {
  t: _propTypes.default.func.isRequired,
  history: _propTypes.default.object,
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string.isRequired
  }),
  getSubMenuConfig: _propTypes.default.func,
  roleId: _propTypes.default.number
};
var _default = AdminDashboard;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/dashboard/admin-dashboard.js
// module id = 752
// module chunks = 0